/**
 * Hook léger pour poller le compteur d'entrées Wave en attente.
 * Utilisé par la sidebar (badge sur "Rapprochement") et par le titre de l'onglet Encaissements.
 *
 * - Polling toutes les 60s + refresh au focus fenêtre.
 * - Silencieux en cas d'erreur (403, réseau) : renvoie 0.
 * - Ignoré pour les rôles sans wave.view (badge 0).
 */
import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const POLL_MS = 60 * 1000;

export function useWavePendingCount({ enabled = true } = {}) {
  const [counts, setCounts] = useState({ merchantUnlinked: 0, agentUnclassified: 0, total: 0 });

  const fetchCounts = useCallback(async () => {
    if (!enabled) return;
    try {
      const { data } = await axios.get(`${API}/wave/inflows/pending-counts`);
      setCounts({
        merchantUnlinked: Number(data?.merchantUnlinked || 0),
        agentUnclassified: Number(data?.agentUnclassified || 0),
        total: Number(data?.total || 0),
      });
    } catch {
      // Silencieux : l'utilisateur n'a peut-être pas la permission
      setCounts({ merchantUnlinked: 0, agentUnclassified: 0, total: 0 });
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return undefined;
    fetchCounts();
    const iv = setInterval(fetchCounts, POLL_MS);
    const onFocus = () => fetchCounts();
    const onCustomRefresh = () => fetchCounts();
    window.addEventListener('focus', onFocus);
    window.addEventListener('wave-pending-refresh', onCustomRefresh);
    return () => {
      clearInterval(iv);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('wave-pending-refresh', onCustomRefresh);
    };
  }, [enabled, fetchCounts]);

  return { ...counts, refresh: fetchCounts };
}

export default useWavePendingCount;
